import { EntityAdapter, createEntityAdapter, EntityState } from '@ngrx/entity';

import { Persona } from './entity-personas.model';
import { Error } from '@rpe/registro-personas-empresas-lib/src/lib/extras/extra-error';

export const entityPersonasAdapter: EntityAdapter<Persona> =
  createEntityAdapter<Persona>({
    selectId: (model) => model.id,
    sortComparer: (a: Persona, b: Persona): number =>
      b.id.toString().localeCompare(a.id.toString())
  });

export interface EntityPersonasState extends EntityState<Persona> {
  isLoading?: boolean;
  error?: Error | null;
}

export const initialState: EntityPersonasState =
  entityPersonasAdapter.getInitialState({
    isLoading: false,
    error: null
  });
